"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableTableRowContext = exports.draggable = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var TableContext_1 = require("../../TableContext");
var TableDraggableContext_1 = require("../../TableDraggableContext");
var icon_1 = require("../../../icon");
var noop_1 = require("../../../_util/noop");
var merge_refs_1 = require("../../../_util/merge-refs");
var rowsDraggable_1 = require("./rowsDraggable");
var inject_props_if_target_not_existed_1 = require("../../util/inject-props-if-target-not-existed");
var fallbackColumnKey = "__draggable_addon__";
var cellPaddingWidth = 20;
var reorder = function (list, startIndex, endIndex) {
    var result = Array.from(list);
    if (typeof endIndex === "undefined") {
        return result;
    }
    var _a = tslib_1.__read(result.splice(startIndex, 1), 1), removed = _a[0];
    result.splice(endIndex, 0, removed);
    return result;
};
function draggable(_a) {
    var module = _a.module, _b = _a.width, width = _b === void 0 ? 26 : _b, full = _a.full, _c = _a.icon, icon = _c === void 0 ? "drop" : _c, hideHandler = _a.hideHandler, targetColumnKey = _a.targetColumnKey, _d = _a.onDragEnd, onDragEnd = _d === void 0 ? noop_1.noop : _d, _e = _a.onDragStart, onDragStart = _e === void 0 ? noop_1.noop : _e, _f = _a.draggableRowKeys, draggableRowKeys = _f === void 0 ? "all" : _f, _g = _a.childrenColName, childrenColName = _g === void 0 ? "childrenList" : _g, _h = _a.dragType, dragType = _h === void 0 ? "row" : _h, relations = _a.relations, onExpandedKeysChange = _a.onExpandedKeysChange, expandedKeys = _a.expandedKeys, _j = _a.indent, indent = _j === void 0 ? 20 : _j;
    // 支持新的行拖拽，轻量版本
    if (!module) {
        return rowsDraggable_1.rowsDraggable({
            onDragEnd: onDragEnd,
            onDragStart: onDragStart,
            draggableRowKeys: draggableRowKeys,
            childrenColName: childrenColName,
            dragType: dragType,
            relations: relations,
            onExpandedKeysChange: onExpandedKeysChange,
            expandedKeys: expandedKeys,
            indent: indent,
            icon: icon,
            hideHandler: hideHandler,
            width: width,
            targetColumnKey: targetColumnKey,
        });
    }
    var Draggable = module.Draggable;
    var total = null;
    return {
        getInfo: function () { return ({ name: "draggable" }); },
        onInjectProps: function (props) {
            var records = props.records;
            var columns = tslib_1.__spread(props.columns);
            if (hideHandler !== true) {
                columns = inject_props_if_target_not_existed_1.injectPropsIfTargetNotExisted(props.columns, targetColumnKey, {
                    key: fallbackColumnKey,
                    width: width,
                    header: null,
                    render: function () { return null; },
                });
            }
            total = records.length;
            return tslib_1.__assign(tslib_1.__assign({}, props), { columns: columns, draggable: true });
        },
        onInjectColumn: function (render) { return function (record, rowKey, recordIndex, column, columnIndex) {
            var result = render(record, rowKey, recordIndex, column, columnIndex);
            // 非表头
            if (columnIndex === -1) {
                return result;
            }
            if (recordIndex !== -1 &&
                (column.key === fallbackColumnKey || column.key === targetColumnKey)) {
                result.children = (react_1.default.createElement(DraggableTableRowIcon, { index: columnIndex, icon: icon, hideHandler: hideHandler }));
            }
            return {
                props: result.props,
                children: (react_1.default.createElement(DraggableTableCell, { index: columnIndex }, result.children)),
            };
        }; },
        onInjectRow: function (render) { return function (record, rowKey, recordIndex) {
            var args = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args[_i - 3] = arguments[_i];
            }
            var result = render.apply(void 0, tslib_1.__spread([record, rowKey, recordIndex], args));
            var row = (react_1.default.createElement(Draggable, { key: rowKey, draggableId: rowKey, index: recordIndex }, function (provided, snapshot) { return (react_1.default.createElement(exports.DraggableTableRowContext.Provider, { value: { provided: provided } }, react_1.default.cloneElement(result.row, tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, provided.draggableProps), (full ? provided.dragHandleProps : {})), { style: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (result.row.props.style || {})), provided.draggableProps.style), (full ? provided.dragHandleProps.style : {})), ref: provided.innerRef, className: classnames_1.default(result.row.props.className, {
                    "is-dragging": snapshot.isDragging,
                }) })))); }));
            return tslib_1.__assign(tslib_1.__assign({}, result), { row: recordIndex === total - 1 ? (react_1.default.createElement(react_1.Fragment, { key: rowKey },
                    row,
                    react_1.default.createElement(DraggableTablePlaceHolder, null))) : (row) });
        }; },
        onInjectBody: function (render) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (react_1.default.createElement(DraggableTableBody, { module: module, onDragStart: onDragStart, onDragEnd: function (context) {
                    var _a, _b;
                    var records = args[0];
                    onDragEnd(reorder(records, (_a = context.source) === null || _a === void 0 ? void 0 : _a.index, (_b = context.destination) === null || _b === void 0 ? void 0 : _b.index), context);
                } }, render.apply(void 0, tslib_1.__spread(args))));
        }; },
    };
}
exports.draggable = draggable;
exports.DraggableTableRowContext = react_1.default.createContext({});
var DraggableTableBody = react_1.default.forwardRef(function (_a, ref) {
    var module = _a.module, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, children = _a.children, props = tslib_1.__rest(_a, ["module", "onDragEnd", "onDragStart", "children"]);
    var DragDropContext = module.DragDropContext, Droppable = module.Droppable;
    var _b = tslib_1.__read(react_1.useState(false), 2), isDragging = _b[0], setIsDragging = _b[1];
    return (react_1.default.createElement(DragDropContext, { onBeforeDragStart: function () { return setIsDragging(true); }, onDragStart: function (context) { return onDragStart(context); }, onDragEnd: function (result) {
            setIsDragging(false);
            onDragEnd(result);
        } },
        react_1.default.createElement(Droppable, { droppableId: "droppable" }, function (provided) {
            return (react_1.default.createElement(TableDraggableContext_1.TableDraggableContext.Provider, { value: {
                    isDragging: isDragging,
                    placeholder: provided.placeholder,
                } }, react_1.default.cloneElement(children, tslib_1.__assign(tslib_1.__assign({}, props), { ref: merge_refs_1.mergeRefs(provided.innerRef, ref), className: classnames_1.default(children.props.className, props.className, {
                    "is-dragging": isDragging,
                }) }))));
        })));
});
function DraggableTableRowIcon(_a) {
    var icon = _a.icon, index = _a.index, hideHandler = _a.hideHandler;
    var columnsWidths = react_1.useContext(TableContext_1.TableContext).columnsWidths;
    var isDragging = react_1.useContext(TableDraggableContext_1.TableDraggableContext).isDragging;
    var provided = react_1.useContext(exports.DraggableTableRowContext).provided;
    if (!provided) {
        return null;
    }
    return (react_1.default.createElement("div", { style: isDragging
            ? { width: columnsWidths[index] - cellPaddingWidth }
            : undefined, className: classnames_1.default({
            "hover-icon": hideHandler === "unhover" && !isDragging,
        }) },
        react_1.default.createElement(icon_1.Icon, tslib_1.__assign({ type: icon }, provided.dragHandleProps))));
}
function DraggableTablePlaceHolder() {
    var placeholder = react_1.useContext(TableDraggableContext_1.TableDraggableContext).placeholder;
    return react_1.default.createElement(react_1.default.Fragment, null, placeholder);
}
function DraggableTableCell(_a) {
    var index = _a.index, children = _a.children;
    var columnsWidths = react_1.useContext(TableContext_1.TableContext).columnsWidths;
    var isDragging = react_1.useContext(TableDraggableContext_1.TableDraggableContext).isDragging;
    return (react_1.default.createElement("div", { style: {
            width: isDragging ? columnsWidths[index] - cellPaddingWidth : undefined,
        } }, children));
}
//# sourceMappingURL=draggable.js.map